var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "custom-callout",
        {
          staticClass: "mb-4 custom-callout bg-white",
          attrs: {
            "border-color": _vm.getBorderColor,
            "custom-class": _vm.getBorderColor,
            "has-toggle": false
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex ml-2" },
            [
              _c("div", { staticClass: "flex-grow-1" }, [
                _c("div", { staticClass: "flex-grow-1 color-gray-6 font-14" }, [
                  _vm._v(" " + _vm._s(_vm.mainTitle) + " ")
                ]),
                _c(
                  "div",
                  { staticClass: "color-black font-weight-bold font-25" },
                  [_vm._v(_vm._s(_vm.count))]
                )
              ]),
              _c("action-button", {
                staticClass: "d-none d-md-block d-sm-none",
                attrs: { i: "fas fa-print", variant: "outline-success" },
                on: {
                  click: function($event) {
                    return _vm.$emit("print")
                  }
                }
              })
            ],
            1
          ),
          _c("hr", { staticClass: "mt-2" }),
          _c("div", { staticClass: "font-14 color-gray-6 h-25" }, [
            _vm._v(" " + _vm._s(_vm.description) + " ")
          ]),
          _c("action-button", {
            staticClass: "d-block d-md-none d-sm-block mt-3",
            attrs: { i: "fas fa-print", variant: "outline-success w-100" },
            on: {
              click: function($event) {
                return _vm.$emit("print")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }